import { OperatingSystemType, UserAgent } from '@/src/interfaces/missing-types';

export const getDeviceOS = (userAgent: UserAgent): OperatingSystemType => {
  switch (true) {
    case userAgent.isAndroid:
      return OperatingSystemType.Android;
    case userAgent.isIos:
      return OperatingSystemType.iOS;
    case userAgent.isDesktop:
      return OperatingSystemType.Windows;
    default:
      return OperatingSystemType.All;
  }
};
